// importando estilização do botão
import style from './ButtonClose.module.css'
//importando icones
import icons from '../../../../img/icons/icons';

interface IButtonClose {
  onClick: () => void;
}

export const ButtonClose: React.FC <IButtonClose> = ({onClick}) =>{  
  return (       
    // aqui dentro vamos colocar nosso JSX     
    <button onClick={onClick} className={style.btnClose} >
      <img src={icons.close} alt = ""></img>          
    </button>                 
  )
}


